/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online text diff tool. Paste two blocks of text and see a line-by-line comparison with additions and removals highlighted. Nothing is uploaded.`)
};

const es_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita en línea para comparar textos. Pega dos bloques de texto y ve una comparación línea por línea con adiciones y eliminaciones resaltadas. Nada se carga en línea.`)
};

const de_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Online-Text-Diff-Tool. Füge zwei Textblöcke ein und sehe einen Vergleich Zeile für Zeile mit hervorgehobenen Hinzufügungen und Entfernungen. Nichts wird hochgeladen.`)
};

const nl_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online tekstdiff-tool. Plak twee blokken tekst in en zie een regel-voor-regel vergelijking met toevoegingen en verwijderingen gemarkeerd. Niets wordt geüpload.`)
};

const fr_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit de diff textuel en ligne. Collez deux blocs de texte et voyez une comparaison ligne par ligne avec les ajouts et les suppressions mises en surbrillance. Rien n'est téléchargé.`)
};

const it_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito di confronto testi online. Incolla due blocchi di testo e vedi un confronto riga per riga con aggiunte e rimozioni evidenziate. Nulla viene caricato.`)
};

const pt_br2_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita online de diferenças de texto. Cole dois blocos de texto e veja uma comparação linha por linha com adições e remoções destacadas. Nada é enviado.`)
};

const pt_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita online de comparação de texto. Cole dois blocos de texto e veja uma comparação linha a linha com adições e removals destacadas. Nada é enviado.`)
};

const ja_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインテキスト差分ツール。2つのテキストブロックを貼り付けて、追加と削除がハイライト表示された行ごとの比較を確認します。アップロードされるものはありません。`)
};

const zh_td_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线文本比较工具。粘贴两段文本，即可查看逐行比较结果，新增和删除内容会以高亮显示。不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_meta_description", locale)
	if (locale === "en") return en_td_meta_description(inputs)
	if (locale === "es") return es_td_meta_description(inputs)
	if (locale === "de") return de_td_meta_description(inputs)
	if (locale === "nl") return nl_td_meta_description(inputs)
	if (locale === "fr") return fr_td_meta_description(inputs)
	if (locale === "it") return it_td_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_td_meta_description(inputs)
	if (locale === "pt") return pt_td_meta_description(inputs)
	if (locale === "ja") return ja_td_meta_description(inputs)
	return zh_td_meta_description(inputs)
};